import React, { useEffect, useState } from "react";
import style from "./productSearchbar.module.scss";
import ToEng from "../../helpers/actions/toEnglishNumber";
import toPersianNumber from "../../helpers/actions/toPersianNumber";
import PhoneNumberRegex from "../../helpers/actions/phoneNumberRegex"
import { withRouter } from "react-router-dom"

const ProductSearchbar = (props) => {
    const [value, setValue] = useState('')
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        if (typeof value != 'undefined' && !PhoneNumberRegex(value)) {
            const delaySearch = setTimeout(() => {
                if (value != props.value) {
                    setLoading(false)
                    props.searchValue(value, props.tag)
                }
            }, 3000)
            return () => {
                clearTimeout(delaySearch)
            }
        } else {
            setLoading(false)
            setValue('')
        }
    }, [value])

    useEffect(() => {
        if (value != props.value) {
            setValue(props.value)
        }
    }, [props.value])

    let nameInput = ['']

    useEffect(() => {
        // nameInput[0].focus();
    }, [])

    return (
        <div className={style.wrapper}>
            <button onClick={e => props.searchValue(value, props.tag)}>
                {loading ?
                    <div className={style.roller}>
                        <div></div><div></div><div></div><div></div>
                    </div>
                    : 'جستجو'}
            </button>
            <div className={style.inputWrapper}>
                <div className={style.hiddenInputWrapper}>
                    <input type="text" value="" name="username" className={style.hiddenInput}></input>
                    <input type="text" value="" name="password" className={style.hiddenInput}></input>
                </div>
                <input
                    ref={(input) => { nameInput[0] = input }}
                    type="text"
                    placeholder={props.placeholder}
                    onChange={(event) => {
                        setLoading(true)
                        setValue(ToEng(event.target.value))
                    }}
                    value={toPersianNumber(value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            props.searchValue(value, props.tag)
                        }
                    }}
                    autoComplete="off"
                    name="mobishaSearch"
                />
            </div>
        </div>
    )

}

export default withRouter(ProductSearchbar);